import { useRef, useState } from "react";

import { Pagination } from "../../pagination"
import { StyledTableOptionsContainer, StyledCustomSelect } from "./table-options.style"
import { MdKeyboardArrowDown } from 'react-icons/md'
import { FilterMenu } from "../../filter-menu";
import { Button } from "../../button";


const TableOptions = ({ currentPage, totalCount, pageSize, setPageSize, onPageChange }) => {
    const [filterMenuVisibility, setFilterMenuVisibility] = useState(false);
    const filterMenuRef = useRef(null);

    const handleSelectChange = (e) => {
        setPageSize(Number(e.target.value))
    }
    return (
        <StyledTableOptionsContainer>
            <div className="page-number-container">
                <div
                    style={{ position: 'relative' }}
                    ref={filterMenuRef}
                    tabIndex={0}
                    onClick={() => setFilterMenuVisibility(!filterMenuVisibility)}
                    onKeyDown={() => setFilterMenuVisibility(!filterMenuVisibility)}
                >
                    <Button
                        size="small"
                    >
                        Filter
                    </Button>
                </div>

                <span>Showing</span>
                <StyledCustomSelect>
                    <select onChange={handleSelectChange}>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={300}>300</option>
                        <option value={400}>400</option>
                        <option value={500}>500</option>
                    </select>
                    <MdKeyboardArrowDown size={20} />
                </StyledCustomSelect>

                <span>out of {totalCount}</span>
            </div>
            <div className="pagination-guy">
                <Pagination
                    currentPage={currentPage}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={onPageChange}
                />
            </div>
            <FilterMenu
                left="0px"
                top="-767px;"
                ref={filterMenuRef}
                visible={filterMenuVisibility}
                onClose={() => setFilterMenuVisibility(false)}
            />
        </StyledTableOptionsContainer>
    )
}

export { TableOptions }